package nl.volleyplanner.api.backend_jobs

import kotlinx.serialization.*
import kotlinx.serialization.json.*

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@JsonClassDiscriminator("version")
sealed class NevoboSyncJobDetailsBase : NevoboSyncJobDetails

// TODO: Figure out a better way to make versioning work without duplicating fields
interface NevoboSyncJobDetails {
    companion object {
        fun decodeJson(jsonData: String) : NevoboSyncJobDetails {
            return if (!jsonData.contains("version")) {
                Json.decodeFromString<NevoboSyncJobDetailsV1>(jsonData)
            } else {
                Json.decodeFromString<NevoboSyncJobDetailsBase>(jsonData)
            }
        }
    }

    val completionPercentage: Int
    val clubsRetrievedAmount: Int
    val matchesRetrievedAmount: Int
    val poulesRetrievedAmount: Int
    val teamsRetrievedAmount: Int
}

@Serializable
data class NevoboSyncJobDetailsV1(
    override val completionPercentage: Int,
    override val clubsRetrievedAmount: Int,
    override val matchesRetrievedAmount: Int,
    override val poulesRetrievedAmount: Int,
    override val teamsRetrievedAmount: Int
) : NevoboSyncJobDetails

@Serializable
@SerialName("V2")
data class NevoboSyncJobDetailsV2(
    val seasonName: String,
    override val completionPercentage: Int,
    override val clubsRetrievedAmount: Int,
    override val matchesRetrievedAmount: Int,
    override val poulesRetrievedAmount: Int,
    override val teamsRetrievedAmount: Int
) : NevoboSyncJobDetailsBase()
